import React, { useContext, useEffect, useState } from "react";
import HeaderInner from "./Components/HeaderInner";
import { Accordion, AccordionTab } from "primereact/accordion";
import axios from "./axios";
import { useLocation } from "react-router-dom";
import SpaLoader from "./Components/Loaders/SpaLoader";
import Title from "./new-components/title/Title";
import NewFooter from "./NewFooter";
import { ThemeContext } from "./context/ThemeContext";

const GuestDirectory = () => {
  const location = useLocation();

  const rawPath = location.pathname;
  const room_uuid = rawPath.split("/")[1];
  const [guest_directory, setGuest_directory] = useState([]);
  // guest_directory_grouping.sorted_by_order: one ordered list mixing both
  // kinds of entry -> [{ type: "directory" | "category", data: {...} }]
  const [sortedDirectory, setSortedDirectory] = useState([]);
  const [loading, setLoading] = useState(false);
  const [header_title, setheader_title] = useState("");
  const lang = localStorage.getItem("lang");
  const { theme } = useContext(ThemeContext);
  // const new_design = localStorage.getItem("new_design");
  // const theme = new_design == "true";

  useEffect(() => {
    setLoading(true);
    const getGuestDirectory = async () => {
      // axios.get(`/648ed77e-da78-4987-9b86-de515659fc2c`).then((res) => {
      axios
        .get(`/${room_uuid}/guest-directory`, {
          headers: {
            lang: lang,
          },
        })
        .then((res) => {
          const data = res.data.data;
          setheader_title(data?.header_title);
          setGuest_directory(data.guest_directory);
          setSortedDirectory(
            data?.guest_directory_grouping?.sorted_by_order || [],
          );
        })
        .finally(() => {
          setLoading(false);
        });
    };
    getGuestDirectory();
  }, []);

  const accordionProps = {
    multiple: true,
    expandIcon: "fa fa-plus",
    collapseIcon: "fa fa-minus",
  };

  // A single directory entry: an accordion tab holding its html body
  const renderDirectoryTab = (directory) => {
    if (!directory || (!directory.title && !directory.body)) return null;

    return (
      <AccordionTab
        key={`directory-${directory.id}`}
        header={directory.title}
        disabled={directory.disabled}
      >
        <div
          dangerouslySetInnerHTML={{
            __html: directory.body,
          }}
        />
      </AccordionTab>
    );
  };

  // A single category: its own directories first, then any child categories.
  // Children come through unwrapped (plain category objects, no `type`).
  const renderCategoryTab = (category, level = 0) => {
    if (!category?.name) return null;

    const children = [
      ...(category.directories || []).map(renderDirectoryTab),
      ...(category.children || []).map((child) =>
        renderCategoryTab(child, level + 1),
      ),
    ].filter(Boolean);

    return (
      <AccordionTab
        key={`category-${category.id}`}
        header={category.name}
        className={`guest-directory-category guest-directory-category-level-${level}`}
      >
        {children.length > 0 && (
          <Accordion {...accordionProps}>{children}</Accordion>
        )}
      </AccordionTab>
    );
  };

  const renderSortedTabs = (items = []) =>
    items
      .map((item) =>
        item?.type === "category"
          ? renderCategoryTab(item.data)
          : renderDirectoryTab(item?.data),
      )
      .filter(Boolean);

  const sortedTabs = renderSortedTabs(sortedDirectory);

  return (
    <div className={theme ? "food" : ""}>
      {theme ? (
        <Title title={header_title} />
      ) : (
        <HeaderInner headerName={header_title} />
      )}
      <main className="home-main bg-white back-white pad-top-0 px-4">
        {loading ? (
          <SpaLoader />
        ) : (
          <Accordion {...accordionProps}>
            {sortedTabs.length > 0
              ? sortedTabs
              : (guest_directory || []).map(renderDirectoryTab).filter(Boolean)}
          </Accordion>
        )}
      </main>
      {theme && <NewFooter />}
    </div>
  );
};

export default GuestDirectory;
